/**
 * slouzi pro zobrazeni tlacitka pro regeneraci kodu az po uplynuti predem urceneho casu
 * melo by to zamezit spamovani emailu pomoci tlacitka pro regeneraci kodu
 * ochrana je i na server side v PHP, nejen skryvanim/zobrazenim tlacitka
 */
export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const button = document.querySelector('#frm-codeForm-form input[name="regenerate"]');
		if (button) {
			const showButtonDate = button.getAttribute('data-show-button-date');

			if (showButtonDate) {
				const targetDate = new Date(showButtonDate);

				const checkTime = () => {
					const currentDate = new Date();
					const span = button.previousElementSibling;

					if (currentDate >= targetDate) {
						button.style.display = 'inline-block';
						if (span instanceof HTMLElement && span.classList.contains('show-span-countdown')) {
							span.classList.add('hidden');
						}
						clearInterval(interval);
					} else {
						if (span instanceof HTMLElement && span.classList.contains('show-span-countdown')) {
							let timeSpan = span.querySelector('span');
							if (timeSpan instanceof Element) {
								timeSpan.innerText = parseInt((targetDate - currentDate) / 1000);
							}
						}
					}
				};

				checkTime();

				const interval = setInterval(checkTime, 1000);
			}
		}
	});
}
